<nz-input-group [class]="width" [nzPrefix]="prefix" class="relative">
  <input
    [placeholder]="placeholder"
    [class]="
      'placeholder:text-mbaza-gray border-mbaza-gray-dark w-full rounded-full border py-1 pr-8 not-focus-visible:border-none focus:border-none ' +
      height +
      ' ' +
      width
    "
    [ngModel]="searchValue"
    (ngModelChange)="onSearchValueChange($event)"
    (keydown)="onKeyDown($event)"
  />
  <button
    *ngIf="searchValue"
    type="button"
    class="absolute top-1/2 right-3 -translate-y-1/2 transform transition-discrete duration-300"
    (click)="onClearSearch()"
    aria-label="Clear search"
  >
    <img
      [src]="ASSET_CONSTANTS.I_cancel"
      alt="clear search icon"
      height="16"
      width="16"
    />
  </button>
  <img
    *ngIf="!searchValue"
    [src]="ASSET_CONSTANTS.I_search"
    alt="search icon"
    height="16"
    width="16"
    class="pointer-events-none absolute top-1/2 right-3 -translate-y-1/2 transform transition-discrete duration-300"
  />
</nz-input-group>

<ng-template #prefix>
  <span class="input-label pr-2 font-bold">{{ prefixLabel }}</span>
</ng-template>
